<template>
    <div>
        <form @submit.prevent="save" class="form-horizontal">
            <div class="p-20">
                <div class="row">
                    <div class="col-xs-12 m-b-15" :class="{'has-error': errors['title']}" v-pml-block="isLoading">
                        <label>{{ $t('template_title') }}</label>
                        <input type="text" v-pml-focus class="form-control" v-model="record.title">
                        <span class="error" v-if="errors['title']">{{ errors['title'][0] }}</span>
                    </div>
                    <div class="col-xs-12 m-b-15" :class="{'has-error': errors['subject']}">
                        <label>{{ $t('subject') }}</label>
                        <input type="text" class="form-control" v-model="record.subject">
                        <span class="error" v-if="errors['subject']">{{ errors['subject'][0] }}</span>
                    </div>
                    <div class="col-xs-12 m-b-15" :class="{'has-error': errors['member_id']}">
                        <label>{{ $t('consultant') }}</label>
                        <pml-select-members v-model="record.member_id" :placeholder="$t('all')"></pml-select-members>
                        <small class="show text-muted m-t-5" v-if="member.is_admin">{{ $t('leave_blank_to_apply_for_everyone') }}</small>
                        <span class="error" v-if="errors['member_id']">{{ errors['member_id'][0] }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" :class="{'has-error': errors['body']}">
                        <label>{{ $t('message') }}</label>
                        <pml-summernote v-model="record.body" :value="record.body" :show-deal-btn="true" :show-member-btn="true" :show-company-btn="true"></pml-summernote>
                        <span class="error" v-if="errors['body']">{{ errors['body'][0] }}</span>
                    </div>
                </div>
            </div>
            <div class="p-20 p-t-0 p-b-0 clearfix">
                <router-link :to="{ name: 'templates.index' }" class="btn btn-white btn_na">{{ $t('cancel') }}</router-link>
                <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
            </div>
        </form>
        <hr class="m-b-0">
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { get, create, update } from 'services/templates'
    import { mapGetters, mapActions } from 'vuex'
    import { isNil, cloneDeep } from 'lodash'

    export default {
        name: 'TemplatesForm',
        data () {
            return {
                indexRoute: 'templates.index',
                isLoading: false,
                record: {
                    member_id: null,
                    body: null
                },
                errors: [],
                isSaving: false
            }
        },
        mounted () {
            this.init()
            if (!this.member.is_admin && this.record.member_id === null)
                this.record.member_id = this.member.id
        },
        watch: {
            '$route' () {
                this.init()
            },
            'template' (val, old) {
                if (val.id !== undefined)
                    this.record = cloneDeep(val)
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember',
                'templates': 'getTemplates',
                'template': 'getTemplate'
            })
        },
        methods: {
            ...mapActions(['saveTemplate']),
            get: (id) => get(id),
            init () {
                typeof this.$route.params.id !== 'undefined' ? this.fetchRecord(this.$route.params.id) : this.clear()
            },
            fetchRecord (id) {
                this.isLoading = true
                this.get(id)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            save () {
                this.isSaving = true

                this.request()
                    .then(() => {
                        Notify.success(trans('the_record_has_been_saved'))
                        this.$router.push({ name: 'templates.index' })
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => {
                        this.isSaving = false
                    })
            },
            request () {
                return isNil(this.record.id) ? create(this.record) : update(this.$route.params.id, this.record)
            },
            clear () {
                this.record = {
                    member_id: null,
                    body: null
                }
                this.errors = []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/templates/components/Form.vue